import $ from 'jquery';

const searchFilter = {

	init: () => {
		$( '.search-results__sort-wrapper select' ).on(
			'change',
			function(e) {

				let $this       = $( this ),
					order       = $this.find( ':selected' ).data( 'order' ),
					orderby     = $this.find( ':selected' ).data( 'orderby' ),
					currentpage = $( '#filter_results' ).attr( 'data-page' ),
					postperpage = $( '#filter_results' ).attr( 'data-ppp' ),
					form        = e.target.closest( "#filter" ),
					search      = $( form ).find( '#query' ).val();

				$.ajax(
					{
						method: "POST",
						url: search_filter.ajaxurl,
						data: {
							'action' : 'search_filter',
							'order' : order,
							'orderby' : orderby,
							'search' : search,
							'ppp' : postperpage,
							'currentpage' : currentpage
						},
					}
				).done(
					function (data) {
						$( ".search-results__wraper-result" ).html( data );

						$( '#filter_results' ).attr( 'data-order',order )
						$( '#filter_results' ).attr( 'data-orderby',orderby )
					}
				);

			}
		)

	}


}

export default searchFilter;
